var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9587 2H14.5033C13.6245 2 12.9121 2.71239 12.9121 3.59116V9.04658C12.9121 9.92535 13.6245 10.6377 14.5033 10.6377H19.9587C20.8375 10.6377 21.5498 9.92535 21.5498 9.04658V3.59116C21.5498 2.71239 20.8375 2 19.9587 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5346 16.1045L18.3559 12.9258C18.0571 12.6281 17.6526 12.4609 17.2309 12.4609C16.8091 12.4609 16.4046 12.6281 16.1059 12.9258L12.9271 16.1045C12.6292 16.4032 12.4619 16.8077 12.4619 17.2295C12.4619 17.6513 12.6292 18.0559 12.9271 18.3545L16.1059 21.5333C16.4044 21.8313 16.809 21.9986 17.2309 21.9986C17.6527 21.9986 18.0573 21.8313 18.3559 21.5333L21.5346 18.3545C21.8327 18.056 22.0001 17.6514 22.0001 17.2295C22.0001 16.8077 21.8327 16.4031 21.5346 16.1045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04755 2H3.59214C2.71336 2 2.00098 2.71239 2.00098 3.59116V9.04658C2.00098 9.92535 2.71336 10.6377 3.59214 10.6377H9.04755C9.92633 10.6377 10.6387 9.92535 10.6387 9.04658V3.59116C10.6387 2.71239 9.92633 2 9.04755 2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04755 12.9102H3.59214C2.71336 12.9102 2.00098 13.6225 2.00098 14.5013V19.9567C2.00098 20.8355 2.71336 21.5479 3.59214 21.5479H9.04755C9.92633 21.5479 10.6387 20.8355 10.6387 19.9567V14.5013C10.6387 13.6225 9.92633 12.9102 9.04755 12.9102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.745baba86d57795caa8fff90426ba450.svg";
export { ForwardRef as ReactComponent };